import { useEffect, useCallback } from 'react';

/* To lock body for older IOS safari, the following css is needed:
	 overflow: hidden;
	 height: 100%;
	 width: 100%;
	 position: fixed;
	 top, right, bottom, left: 0;
*/
const BODY_LOCK_CLASSES = ['u-oh', 'u-width-100', 'u-height-100', 'u-fixed', 'u-pos-r0', 'u-pos-b0', 'u-pos-l0'];

/**
 * @param {Boolean} shouldLockBody - Lock/unlock body scroll on mount/unmount
 */
export default function useLockBodyScroll(shouldLockBody) {
	const lockBody = () => {
		document.body.style.top = `-${window.scrollY}px`;
		document.body.classList.add(...BODY_LOCK_CLASSES);
	};

	const unlockBody = useCallback(() => {
		const scrollY = document.body.style.top;
		document.body.classList.remove(...BODY_LOCK_CLASSES);
		document.body.style.top = '';

		if (shouldLockBody) {
			window.scrollTo(0, Number.parseInt(scrollY || '0', 10) * -1);
		}
	}, [shouldLockBody]);

	const bodyScrollIsLocked = () => {
		return document.body.classList.contains('u-oh');
	};

	useEffect(() => {
		if (shouldLockBody) {
			lockBody();
		}

		return () => {
			unlockBody();
		};
	}, [shouldLockBody, unlockBody]);

	return { lockBody, unlockBody, bodyScrollIsLocked };
}
